import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { teamsProjectsByTeamIdSelector } from 'state/selectors/projects';
import useFiltersPayloadIssuesKeys from './useFiltersPayloadIssuesKeys';
import { isEmpty, omitBy } from 'lodash';

const useLinbTeamsEntities = ({ teamsIds = [], isTreeHierarchyEnabled }) => {
  const teamsProjectsByTeamId = useSelector(teamsProjectsByTeamIdSelector);
  const issuesKeys = useFiltersPayloadIssuesKeys();

  const initTeamsEntities = () => {
    const teamsEntities = teamsIds.reduce((acc, teamId) => {
      const teamProject = teamsProjectsByTeamId[teamId];
      const filter = teamProject?.filter || {};
      const { boards = [], epics = [], labels = [], fields = [] } = filter;
      const boardsIds = boards.map(board => board?.provider_id).filter(Boolean);
      const epicsIds = epics.map(epic => epic?.provider_id).filter(Boolean);
      const labelsValues = labels.map(label => label?.name).filter(Boolean);
      const fieldsObj = fields.reduce((acc, field) => {
        const { id, value: values = [] } = field || {};
        const isValidField = !!id && values?.length > 0;
        return {
          ...acc,
          ...(isValidField && { [id]: values })
        };
      }, {});

      const oldIssues = omitBy(
        {
          [issuesKeys.parentOne]: epicsIds
        },
        isEmpty
      );
      const issuesIds = [...epicsIds];

      const payload = {
        boards_ids: boardsIds,
        ...(isTreeHierarchyEnabled
          ? { issue_ids: issuesIds }
          : { issues: oldIssues }),
        labels: labelsValues,
        fields: fieldsObj
      };
      const teamPayload = omitBy(payload, isEmpty);

      return {
        ...acc,
        ...(teamPayload && { [teamId]: teamPayload })
      };
    }, {});
    return teamsEntities;
  };

  const teamsEntities = useMemo(initTeamsEntities, [teamsIds]);
  return teamsEntities;
};

export default useLinbTeamsEntities;
